let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("16ht2"), load("joJy8"), load("aHE9G"), load("kKNsN")]).then(() => parcelRequire('1vSpd'));